"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _transferServicesDataActions = require("../actions/transferServicesDataActions");

function transferServiceData() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _transferServicesDataActions.TRANSFER_SERVICES_DATA_RECEIVED:
            return action.transferServiceData;
        default:
            return state;
    }
}

exports.default = transferServiceData;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/reducers/transferServices.js
// module id = 1404
// module chunks = 0